import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { EmptyTicket } from "./EmptyTicket";
import { IModel } from "./TicketMast";
import { Search } from "../../shared/Search";
import { ITicketMast } from "../../models/TicketMast";
import { Assign } from "./Assign";
import { ILogin, IPermissionProps } from "../../models/Login";
import { EmptyTicketSub, ITicketSub, TicketSub } from "./TicketSub";
import { format } from "date-fns";
import { TicketHistory } from "./TicketHistory";

interface Iprops {
    setModal: (modal: IModel) => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
    permissions: IPermissionProps
}

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<ITicketMast>, loading: boolean });
    const [tableDataSub, setTableDataSub] = useState({ tableData: [], loading: false } as { tableData: Array<ITicketSub>, loading: boolean });
    const [totalRecords, setTotalRecords] = useState(0);
    const [tb, setTb] = useState(1);
    const [globalFilter, setGlobalFilter] = useState<string | null>(null);
    const dt = useRef<any>(null);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'ticket_ID',
        sortOrder: -1
    });

    const [modalHistory, setModalHistory] = useState({ singleData: {}, open: false } as { singleData: ITicketMast, open: boolean });
    const [reload, setReload] = useState(false);
    const hideDialogHistory = () => {
        setModalHistory({ singleData: {}, open: false })
    };

    useEffect(() => {
        if (tb !== 4) {
            getTableDataCount();
            loadTableData();
        }
        else loadTableDataSub();
    }, [globalFilter, lazyParams, tb, props.reload]);

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async () => {
        setTableData({ tableData: [], loading: true });
        const response = await Fetch("Ticket", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filter=${globalFilter}&tb=${tb}`, props.toast);
        if (response) {
            const data: Array<ITicketMast> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }
    const getTableDataCount = async () => {
        const response = await Fetch("Ticket/count", "GET", null, `filter=${globalFilter}&tb=${tb}`, props.toast);
        if (response) {
            const count: number = parseInt(await response.text(), 10);
            setTotalRecords(count);
        }
    }

    const loadTableDataSub = async () => {
        setTableDataSub({ tableData: [], loading: true });
        const response = await Fetch("Ticket/subject", "GET", null, `filter=${globalFilter}`, props.toast);
        if (response) {
            const data: Array<ITicketSub> = await response.json();
            setTableDataSub({ tableData: data, loading: false });
        }
    }

    const openNew = () => {
        props.setModal({ open: true, singleData: EmptyTicket });
    };
    const openNewSub = () => {
        setTsub({ open: true, singleData: EmptyTicketSub });
    };

    const openEdit = (rowDatauser: ITicketMast) => {
        props.setModal({ open: true, singleData: rowDatauser });
    };
    const openEditSub = (rowDatauser: ITicketSub) => {
        setTsub({ open: true, singleData: rowDatauser });
    };

    const [assignT, setAssignT] = useState({ ticket_ID: 0, department: 0, open: false });
    const hideAssignT = () => {
        setAssignT({ ticket_ID: 0, department: 0, open: false });
    }
    const [tsub, setTsub] = useState({ singleData: {}, open: false } as { singleData: ITicketSub, open: boolean });
    const hideTsub = () => {
        setTsub({ singleData: {}, open: false });
    }

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    {props.permissions.is_Create && <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />}
                    <Button label="MyTickets" className={tb === 1 ? "p-button-info mr-2" : "p-button-secondary mr-2"} onClick={() => setTb(1)} />
                    {props.permissions.is_Update && <Button label="AssignedToMe" className={tb === 2 ? "p-button-info mr-2" : "p-button-secondary mr-2"} onClick={() => setTb(2)} />}
                    {(_roles.includes(1) || _roles.includes(26) || _roles.includes(13)) && <Button label="AllTickets" className={tb === 0 ? "p-button-info mr-2" : "p-button-secondary mr-2"} onClick={() => setTb(0)} />}
                    {(_roles.includes(1) || _roles.includes(26)) && <Button label="TicketSub" className={tb === 4 ? "p-button-info" : "p-button-secondary"} onClick={() => setTb(4)} />}
                </div>
            </React.Fragment>
        );
    };
    const leftToolbarTemplateSub = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    {props.permissions.is_Create && <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNewSub} />}
                    <Button label="MyTickets" className={tb === 1 ? "p-button-info mr-2" : "p-button-secondary mr-2"} onClick={() => setTb(1)} />
                    {props.permissions.is_Update && <Button label="AssignedToMe" className={tb === 2 ? "p-button-info mr-2" : "p-button-secondary mr-2"} onClick={() => setTb(2)} />}
                    {(_roles.includes(1) || _roles.includes(26) || _roles.includes(13)) && <Button label="AllTickets" className={tb === 0 ? "p-button-info mr-2" : "p-button-secondary mr-2"} onClick={() => setTb(0)} />}
                    {(_roles.includes(1) || _roles.includes(26)) && <Button label="TicketSub" className={tb === 4 ? "p-button-info" : "p-button-secondary"} onClick={() => setTb(4)} />}
                </div>
            </React.Fragment>
        );
    };

    const rightToolbarTemplate = () => {
        return (
            props.permissions.is_Export ?
                <React.Fragment>
                    {props.permissions.is_Export ? <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} /> : ""}
                </React.Fragment> : ''
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">{tb === 1 ? "My Tickets" : tb === 2 ? "Assigned To Me" : "All Tickets"}</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <Search setSearch={setGlobalFilter} />
            </span>
        </div>
    );

    const update = (rowData: ITicketMast) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => openEdit(rowData)} />
            </div>
        );
    };
    const updateSub = (rowData: ITicketSub) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => openEditSub(rowData)} />
            </div>
        );
    };

    const assign = (rowData: ITicketMast) => {
        return (
            <div className="actions">
                {!rowData.assignTo && <Button icon="pi pi-send" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => { if (rowData.ticket_ID && rowData.department) setAssignT({ department: rowData.department, ticket_ID: rowData.ticket_ID, open: true }); }} />}
            </div>
        );
    };

    return (
        <>
            {tb !== 4 ? <>
                <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                    ref={dt} size="small" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                    value={tableData.tableData} lazy dataKey="id"
                    paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                    totalRecords={totalRecords} onPage={onPage}
                    onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                    header={header}
                    loading={tableData.loading}
                >
                    <Column field="ticket_ID" header="Ticket ID" sortable />
                    <Column field="department_Name" header="Department" sortable />
                    <Column field="createdByName" header="Created By" />
                    <Column field="ticket_Subject" header="Subject" body={(rowData)=><Button style={{color: "#0073cf", border:"none", backgroundColor:"white"}} onClick={()=>setModalHistory({ singleData: rowData, open: true })}>{rowData.ticket_Subject}</Button>} />
                    <Column field="ticket_Status" header="Status" sortable />
                    <Column field="assignedToName" header="Assigned To" sortable />
                    {tb === 2 && <Column body={update} />}
                    {tb === 0 && <Column body={assign} />}
                </DataTable>
            </>
                :
                <>
                    <Toolbar className="mb-1 py-0" left={leftToolbarTemplateSub}></Toolbar>
                    <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                        ref={dt} size="small" stripedRows scrollable scrollHeight="65vh"
                        value={tableDataSub.tableData} exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                        header={header}
                        loading={tableDataSub.loading}
                    >
                        <Column field="ticket_Sub" header="Ticket Subject" />
                        <Column field="department_Name" header="Department" />
                        <Column field="user_Name" header="Created By" />
                        <Column body={updateSub} />
                    </DataTable>
                </>}
            <Assign ticket_ID={assignT.ticket_ID} department={assignT.department} open={assignT.open} hideDialog={hideAssignT} reload={props.reload} setReload={props.setReload} toast={props.toast} />
            <TicketSub singleData={tsub.singleData} open={tsub.open} hideDialog={hideTsub} reload={props.reload} setReload={props.setReload} toast={props.toast} />
            <TicketHistory singleData={modalHistory.singleData} open={modalHistory.open} hideDialog={hideDialogHistory} toast={props.toast} reload={reload} setReload={setReload} setModal={setModalHistory}></TicketHistory>
        </>
    );
}
